import { render } from "./TabPanel.vue?vue&type=template&id=a8d3d9d4"
import script from "./TabPanel.vue?vue&type=script&lang=js"
export * from "./TabPanel.vue?vue&type=script&lang=js"
script.render = render

export default script